export default __webpack_public_path__ + "static/media/PlusCircle.e1fe21b5.svg";